import { render, staticRenderFns } from "./PopBatchAdd.vue?vue&type=template&id=61e4bff9&scoped=true&"
import script from "./PopBatchAdd.vue?vue&type=script&lang=js&"
export * from "./PopBatchAdd.vue?vue&type=script&lang=js&"
import style0 from "./PopBatchAdd.vue?vue&type=style&index=0&id=61e4bff9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4bff9",
  null
  
)

export default component.exports